import EventEmitter from "eventemitter3";
import components from "../components/_map";
import { debounce } from "lodash";
import gsap from "gsap/all";
import { CustomEase, MotionPathPlugin } from "gsap/all";
import Utils from "../utils/utils";
import Dropdowns from "../components/dropdowns";
import SiteMenu from "../components/site-menu";
//import LCS from "../components/locomotive-scroll";
import LCS from "../components/lenis-scroll";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { initObfuscatedContacts } from "../utils/obfuscated-contact";

gsap.registerPlugin(MotionPathPlugin)
gsap.registerPlugin(CustomEase);

export default class AppController extends EventEmitter {
	constructor() {
		super();
		if (!AppController.singleton) {
			AppController.singleton = this;
			this.components = [];
			this.gsap = gsap
			this.currentController = document.body.getAttribute('data-controller');
			this.components_map = components;
			this.init();
			return AppController.singleton;
		}
	}
	init() {
		this.isMobile = window.matchMedia('(max-width: 1024px), (pointer: coarse)').matches;
		this.$scroll = this.isMobile ? null : new LCS();

		if (document.body.hasAttribute('data-loader-show')) {
			this.$scroll?.disable();
		}

		this.initAppEvents();
		this.initDomElements();
		this.instantiateComponents();

		this.$dropdowns = new Dropdowns();

		this.initViewportVhVar();
		this.initDetect();
		this.initTextareas();
		this.$menu = new SiteMenu(this);
		initObfuscatedContacts();
	}
	
	initDomElements() {

	}
	initAppEvents() {
		const debouncedResize = debounce((event) => {
			this.emit("resize", event);
		}, 150);

		window.addEventListener("resize", debouncedResize, { passive: true })

		window.addEventListener("scroll", (event) => {
			this.emit("scroll", event);
		})

		window.addEventListener('site-loader:done', () => {
			this.$scroll?.enable();
			this.emit('loader:done');
		}, { once: true });

		window.onhashchange = () => {
			this.emit("hash-change", window.location.href);
		};
		this.on("scrollTo", (elt) => {
			this.$scroll.scrollTo(elt);
		});

		// Navbar events
		this.on("hide-navbar", () => {
			this.$navbarContainer.classList.add('hidden');

		});
		this.on("show-navbar", () => {
			this.$navbarContainer.classList.remove('hidden');
		});

		this.on("disable-scroll", () => {
			if (this.$scroll) {
				// disableBodyScroll(document.body);
				this.$scroll.disable()
			}
		});
		this.on("enable-scroll", () => {
			if (this.$scroll) {
				// enableBodyScroll(document.body);
				this.$scroll.enable()
			}
		});

		this.on('remove-bg-navbar', () => {
			if (!this.$navbar.classList.contains('--scrolling')) {
				this.$navbarContainer.classList.remove('bg-white');
			}
		})
	}
	initTextareas() {
		const tx = document.getElementsByTagName("textarea");
		for (let i = 0; i < tx.length; i++) {
			tx[i].setAttribute("style", "height:" + (tx[i].scrollHeight) + "px;overflow-y:hidden;");
			tx[i].addEventListener("input", OnInput, false);
		}

		function OnInput() {
			this.style.height = "auto";
			this.style.height = (this.scrollHeight) + "px";
		}
	}

	instantiateComponents() {
		const nodes = document.body.querySelectorAll('[data-component]');
		nodes.forEach((el) => {
			const name = el.getAttribute('data-component');
			const mod = this.components_map[name];
			if (!mod) return;
			const Ctor = mod.default || mod;
			if (typeof Ctor === 'function') {
				this.components.push(new Ctor(el));
			}
		});
	}

	initViewportVhVar() {
		this.updateViewportVhVar();
		window.addEventListener("resize", () => {
			this.updateViewportVhVar()
		});
	}
	updateViewportVhVar() {
		let vh = window.innerHeight;
		document.documentElement.style.setProperty('--vh', `${vh / 100}px`);
	}

	initDetect() {
		window.addEventListener("resize", () => {
			this.detectDevice();
		});
		this.detectDevice();
	}
	detectDevice = () => {
		let landscape = window.matchMedia("(orientation: landscape)");
		document.documentElement.setAttribute('data-device-notice', Utils.deviceType() == 'mobile' && landscape.matches && window.innerWidth < 1000);
	}







	static getInstance() {
		return AppController.singleton;
	}
}
